import React from 'react';
import { RouteProps } from 'react-router';
import { Page, ArticleTemplate, PageSection, ArticleImage, ArticleImages, ArtistLinks, ProductLinks, LazyImage, ImageCompare } from '_components';
import { ARTICLES } from 'articles';
import { EQUIPMENT } from 'equipment';
import imgBanner from './banner.jpg';
import img01 from './image01.jpg';
import img02 from './image02.jpg';
import img03 from './image03.jpg';
import img04 from './image04.jpg';
import imgEdit01 from './edit01.jpg';
import imgEdit02 from './edit02.jpg';

const FeatureElisaMinutielloRoute: React.FC<RouteProps> = (props) => {

  const article = ARTICLES.FEATURE_ELISA_MINUTIELLO;

  return (
    <Page className="FeatureElisaMinutielloRoute">

      <ArticleTemplate article={article} banner={imgBanner}>

        <PageSection maxWidth="narrow">
          <p>{article.description}</p>
          <h3>Hi Elisa, let's start with a bit about yourself.</h3>
          <p>Hi! I'm Elisa - I am 23 years old, and I live in the province of Bologna, Italy.</p>
          <p>I studied graphic design at school, today I work in a dress shop. My free time is dedicated to photography, and I hope to make a career of it one day.</p>
          <p>As the old saying goes: “Choose a job you love and you will never have to work a day in your life”. This is the motivation that pushes me everyday to commit myself more to what I love to do, which is photography.</p>
          <ArticleImage image={img01} imagePaddingTop="66.67%" />
          <p>I love photography because it contains a precise moment, and this will never change over time. I like to think that in so many years when I look at these photos, they will take me back in time, with my mind and heart.</p>
          <p>I am also drawn to the ideas of travelling and discovering new places and photographing realities different from mine.</p>
          <h3>How did you first start out in photography?</h3>
          <p>I have always loved the arts even as a child. At school, I took some photography courses, but in the last couple of years I have worked hard to practice and refine my technique. Everyday I am studying, using tutorials, and following people who inspire me. Photography for me is an expression of oneself.</p>
          <p>I remember that my mom had an analog camera that she always carried with her. I was so intrigued and fascinated. A few years later, as a teenager, I received a compact camera as a gift and I had so much fun capturing moments of my friends and family.</p>
          <p>Two years ago, I bought my first DSLR, and since then, photography has totally become an integral part of my life.</p>
          <ArticleImage image={img02} imagePaddingTop="66.67%" />
          <h3>Where do you draw inspiration from?</h3>
          <p>I draw inspiration from other photographers, illustrations, movies, and Instagram's photo community. I also take inspiration from everything around me, even from little details. My style is constantly developing.</p>
          <p>For me it is about evoking emotions, such as, melancholy, loneliness, meditation, quietude... and memories of my childhood. I live in a small mountain town, surrounded by nature and simplicity: it is as if sometimes time has never stopped. I like the idea of conveying this sense of authenticity and gratitude for the little things and memories of the past. Sometimes the world seems to go too fast and we often forget to stop for a moment and observe what surrounds us.</p>
          <h3>What subjects do you like to shoot and why?</h3>
          <p>My preferences on the subject vary depending on how I feel over a certain period or season. I prefer elements of nature (flowers, plants, wood etc) subjects and patterns far from today's society, to give a sense of freedom and bond with nature.</p>
          <p>I like to include vintage elements in my photos (old candle holders, teacups, or even old furniture). I love a nostalgic style, and this helps contribute towards that.</p>
          <p>I am particularly interested in low light photos, especially in these winter months. The cold, the days that get shorter, the fog; they help to make my mood a little dark and melancholy, but at the same time also reflective. I like to convey this in my shots.</p>
          <ProductLinks groups={[
            {
              label: 'Camera Body',
              items: [EQUIPMENT['Nikon D3500'], EQUIPMENT['Lomography Lomo\'Instant']]
            },
            {
              label: 'Camera Lens',
              items: [EQUIPMENT['Nikon AF-S DX NIKKOR 18-140mm f/3.5-5.6G ED'], EQUIPMENT['Nikon AF-P DX NIKKOR 10-20mm f/4.5-5.6G VR']]
            },
          ]} />
          <h3>How do you achieve the look in your photos? What is your editing process?</h3>
          <p>I use Adobe Lightroom (I'm learning to use Photoshop). First I crop and/or straighten the image if needed, Next I adjust the brightness, shadows and contrast. Each of my photos uses different settings (it depends on the time of year and what I want to communicate) but I try to follow a general rough process.</p>
          <p>I tend to prefer darker and not too saturated tones. In recent months, for example, I have been using colors such as teal, petrol, green-water. Sometimes I use grain in editing to make the ensemble a little more vintage (but without exaggerating the effect).</p>
          <p>Every three to four months, I combine the most beautiful photos and create a photobook with them. It's so nice to see and touch your creations, then I don't risk losing them forever (these accidents can happen).</p>
          <ImageCompare
            imageOne={<LazyImage src={imgEdit01} paddingTop="66.67%" />}
            imageTwo={<LazyImage src={imgEdit02} paddingTop="66.67%" />}
            caption="Before and after editing"
          />
          <h3>How has Covid-19 affected your photography?</h3>
          <p>Covid has not drastically affected my photography; I can not travel, but I also love the landscapes near home. On the other hand, I have much more time to devote myself to photography and study.</p>
          <h3>What are your thoughts on Instagram as a photography platform?</h3>
          <p>These days, everyone is a photographer… the unique factors are in the consistency and determination. To have a creative mind, and to be able to convey emotions through what you create. This is not always easy.</p>
          <ArticleImages
            colSpan={6}
            imagePaddingTop="150%"
            items={[
              { image: img03 },
              { image: img04 },
            ]}
          />
          <h3>What are some of your hobbies outside of photography?</h3>
          <p>My hobbies outside of photography are reading, listening to music and, in the last year I have also dedicated myself to plants and gardening. I enjoy meditating or a walk in the woods - I feel all of these feed into my creative process.</p>
          <h3>Thank you for speaking to us Elisa. Any final comments?</h3>
          <p>Thank you very much for the interview, it was a moment of personal reflection. I am grateful to you for having included me in this project.</p>
          <ArtistLinks groups={[
            {
              label: 'Instagram',
              items: [
                { name: '@nuvolarossssa', url: 'https://www.instagram.com/nuvolarossssa' },
              ],
            },
          ]} />
        </PageSection>

      </ArticleTemplate>

    </Page >
  );
};

export { FeatureElisaMinutielloRoute };
export default FeatureElisaMinutielloRoute;
